import {Entity} from './entity';
import {GenericService} from './generic.service';
import {QueryOptions} from './query.options';
import {PaginationPage} from './pagination-page';
import {LazyLoadEvent} from 'primeng/primeng';
import {PaginationPropertySort} from './pagination.property.sort';
import {GlobalAppService} from './global-app.service';
import {PaginationStore} from './pagination-store';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

export class ServerPaginationStore<T extends Entity> implements PaginationStore<T> {
    public page: Observable<PaginationPage<T>>;
    public pageItems: Observable<T[]>;
    public totalElements: Observable<number>;

    protected queryOptions: BehaviorSubject<QueryOptions>;
    protected service: GenericService<T>;
    protected appService: GlobalAppService;

    private static parseOnPageEvent(event: any): Object  {
        const page = Math.floor(event.first / event.rows);
        return {page: page, size: event.rows};
    }

    private static parseOnSortEvent(event: any): Object {
        return {sorts: event.multiSortMeta ?
            event.multiSortMeta.map(sort =>
                ({
                    property: sort.field,
                    direction: sort.order === 1 ?
                        PaginationPropertySort.DIRECTION_ASC :
                        PaginationPropertySort.DIRECTION_DESC
                })) :
            []
        };
    }

    constructor(service: GenericService<T>, appService: GlobalAppService) {
        this.service = service;
        this.appService = appService;
        this.queryOptions = new BehaviorSubject<QueryOptions>(this.service.getDefaultQueryOptions());
        this.page = this.queryOptions.asObservable()
            .do(qo => this.appService.setLoading(true))
            .switchMap(qo => this.doQuery(qo))
            .do(pp => this.appService.setLoading(false))
            .catch(err => { this.appService.setLoading(false); return Observable.of(null); } );
        this.pageItems = this.page.map(pp => pp.content);
        this.totalElements = this.page.map(pp => pp.totalElements);
    }

    protected doQuery(qo: QueryOptions): Observable<PaginationPage<T>> {
        return this.service.query(qo);
    }

    public refresh(): void {
        this.queryOptions.next(this.queryOptions.value);
    }

    public setQueryOptions(queryOptions: QueryOptions) {
        this.queryOptions.next(queryOptions);
    }

    public getQueryOptions(): QueryOptions {
        return this.queryOptions.value;
    }

    public mergeQueryOptions(options: Object): void {
        this.queryOptions.next(this.queryOptions.value.merge(options))
    }

    public updateFromOnPageEvent(event: any): void {
        this.mergeQueryOptions(ServerPaginationStore.parseOnPageEvent(event));
    }

    public updateFromOnSortEvent(event: any): void  {
        this.mergeQueryOptions(ServerPaginationStore.parseOnSortEvent(event));
    }

    public updateFromOnLazyLoadEvent(event: LazyLoadEvent): void {
        const obj = ServerPaginationStore.parseOnPageEvent(event);
        Object.assign(obj, ServerPaginationStore.parseOnSortEvent(event));
        this.mergeQueryOptions(obj);
    }

}



// WEBPACK FOOTER //
// ./src/app/core/commons/server-pagination-store.ts